// extracted by mini-css-extract-plugin
export default {"idLogin":"index_idLogin__mV93u","forget":"index_forget__zVbgj","formItem":"index_formItem__qr63y","tips":"index_tips__o4sd-"};